import service from '@/domain/services/expenses';

export const fetchExpenses = {
  onDispatch: (_, { getState }) => service.getExpenses(getState().state.user),
  fulfilled: (state, { payload }) => {
    state.expenses.items = payload;
  },
};
export const fetchExpenseBills = {
  onDispatch: (query, { getState }) =>
    service.getExpenseBills(query, getState().state.user),
  pending: (state, { meta }) => {
    state.expenses.loading = true;
    state.expenses.requestId = meta.requestId;
    if (meta.arg.page === 1) {
      state.expenses.bills = [];
      state.expenses.page = 0;
      state.expenses.count = 0;
      state.expenses.sum = 0;
      state.expenses.filterExpenseIDs = [];
    }
  },
  fulfilled: (state, { payload, meta }) => {
    const data = state.expenses;
    if (data.requestId !== meta.requestId) return;
    data.loading = false;
    data.page = meta.arg.page;
    data.count = payload.count;
    data.bills =
      meta.arg.page === 1 ? payload.rows : [...data.bills, ...payload.rows];
    if (meta.arg.page === 1) {
      data.sum = Number(payload.sum || 0);
      data.filterExpenseIDs = payload.expense || [];
    }
  },
  rejected: (state, { meta }) => {
    if (state.expenses.requestId === meta.requestId)
      state.expenses.loading = false;
  },
};
const mutation = (method) => ({
  onDispatch: (data, { getState }) =>
    service[method](data, getState().state.user),
  pending: (state) => {
    state.expenses.saving = true;
  },
  fulfilled: (state) => {
    state.expenses.saving = false;
  },
  rejected: (state) => {
    state.expenses.saving = false;
  },
});
export const createExpense = mutation('createExpense');
export const updateExpense = mutation('updateExpense');
export const deleteExpense = mutation('deleteExpense');
export const createExpenseBill = mutation('createExpenseBill');
export const updateExpenseBill = mutation('updateExpenseBill');
export const deleteExpenseBill = mutation('deleteExpenseBill');
